<filter-table
  [title]="title"
  [data]="data"
  [relatedToType]="'Property'"
  [savedView]="savedView"
  [queryFilters]="queryFilters"
  [fieldDefs]="fieldDefs"
  [displayColumns]="displayColumns"
  [dataset]="results_dataset"
  [pagination]="results_pagination"
  [sortState]="sortState"
  (pageEvent)="page($event)"
  (sortEvent)="sort($event)"
  (filterEvent)="filter($event)"
  (searchEvent)="search($event)"
  (updateEvent)="update($event)"
  [allowCsvExport]="true"
  (exportCsvEvent)="exportCsv()"
></filter-table>
